import request from "@/utils/request";

export function getCompanyList() {
  return request({
    url: `/company/manage/list`,
    method: "get"
  });
}

export function getList(data) {
  return request({
    url: `/company/manage/getPagesByCondition`,
    method: "post",
    data: data,
  });
}
export function register(data) {
  return request({
    url: "/company/manage/register",
    method: "post",
    data,
  });
}

export function selectByCurrentUser() {
  return request({
    url: `/company/manage/selectByCurrentUser`,
    method: "get",
  });
}

export function authentication(data) {
  return request({
    url: "/company/manage/authentication",
    method: "post",
    data,
  });
}

export function authenticationStatus() {
  return request({
    url: "/company/manage/authentication/status",
    method: "get",
  });
}

export function enterpriseCount() {
  return request({
    url: "/company/manage/count",
    method: "get"
  });
}

export function pendingCount() {
  return request({
    url: "/company/manage/pending/count",
    method: "get"
  });
}

export function review(data) {
  return request({
    url: "/company/manage/review",
    method: "post",
    data
  });
}

export function insert(data) {
  return request({
    url: "/company/manage/save",
    method: "post",
    data,
  });
}
export function detailById(id) {
  return request({
    url: `/company/manage/detailById?id=${id}`,
    method: "get",
  });
}
export function updateById(data) {
  return request({
    url: "/company/manage/updateById",
    method: "post",
    data,
  });
}

export function deleteById(id) {
  return request({
    url: `/company/manage/deleteById?id=${id}`,
    method: "get",
  });
}
export function deleteByBatchId(data) {
  return request({
    url: "/company/manage/deleteByBatchId",
    method: "post",
    data,
  });
}
export function checkPhoneNumRepeat(id, phoneNum) {
  let isId = "";
  if (id) {
    isId = id;
  }
  return request({
    url: `/company/manage/checkPhoneNumRepeat?id=${isId}&phoneNum=${phoneNum}`,
    method: "get",
  });
}

export function updateStatus(data) {
  return request({
    url: "/company/manage/updateStatus",
    method: "post",
    data,
  });
}